import { isNotDefined } from '@sgme/fp';
import { CutOffResponse } from 'apiConnector/secondary-market/cp-order/model';
import { useAutoRefreshedValue } from 'hooks/useAutoRefreshValue';
import { SecondaryCellRendererProps, SemanticMetadata } from 'routes/secondary-market-batch/grid/types';
import { getSemanticBoundaryLevel } from 'routes/secondary-market-batch/grid/utils/semantic-boundary';
import { RowData } from 'state/workspaces/secondary-market/batch/model';
import { ApiLevel } from 'utils/http/httpClient.model';

const classNameByLevel: Record<ApiLevel, string> = {
  Info: 'text-info',
  Warning: 'text-warning',
  Error: 'text-danger',
  Critical: 'text-danger',
};

export function SemanticDatetimeCellRenderer({
  colDef,
  value,
  valueFormatted,
}: SecondaryCellRendererProps<RowData[keyof RowData]>) {
  const now = useAutoRefreshedValue(() => Temporal.Now.zonedDateTimeISO(), 1000);
  const cutOff = value as CutOffResponse | undefined;
  if (isNotDefined(cutOff)) {
    return null;
  }
  const boundaries: SemanticMetadata = Array.isArray(colDef.context) ? colDef.context : [];
  const level = getSemanticBoundaryLevel(boundaries, cutOff.nextCutOff, now);
  const className = level ? classNameByLevel[level] : undefined;

  return <span className={className}>{valueFormatted ?? cutOff.nextCutOff}</span>;
}
